import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import chatbot from './sidebarItems/chatbotAtenty';
import requests from './sidebarItems/requests';
import client_reports from './sidebarItems/clientReports';
import primaryMenu from './sidebarItems/primaryMenu';
import agentsIa from './sidebarItems/agentAtenty';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    settings(accountId),
    notifications(accountId),
    chatbot(accountId),
    requests(accountId),
    client_reports(accountId),
    agentsIa(accountId) 
  ],
});
